import styled from 'styled-components';
import { device } from './Theme';

export const StyledAbout = styled.section`
  padding: 6rem 1.8rem;
  background: #f5f5f9;

  @media ${device.tablet} {
    padding: 4.2rem 1.8rem;
  }

  @media ${device.mobile} {
    /* padding: 3rem 1.2rem; */
    padding: 3.8rem 1.2rem;
  }
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  max-width: 1000px;
`;

export const Text = styled.div`
  max-width: 48.4rem;
  margin-bottom: 4rem;

  p:first-child {
    margin-bottom: 1rem;
  }

  span {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
  }

  @media ${device.mobile} {
    margin-bottom: 2.5rem;

    p {
      font-size: 0.95rem;
      line-height: 1.65;
    }
    p:first-child {
      margin-bottom: 0.9rem;
    }
  }
`;

export const Skills = styled.div`
  h4 {
    font-size: 1.4rem;
    font-weight: 500;
    letter-spacing: 1px;
    margin-bottom: 2rem;
    color: ${({ theme }) => theme.colors.heading};
  }

  section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1.3rem;
    margin-bottom: 1rem;

    li {
      border: 1px solid #d5d5d5;
      overflow: hidden;
      list-style: none;
      display: flex;
      flex-direction: column;
      border-radius: ${({ theme }) => theme.borderRadius};
    }
    li:nth-child(9) p{
      font-size: .9rem;
    }

    div {
      height: 8rem;
      padding: 1.8rem;
    }

    img {
      width: 100%;
      height: 100%;
    }

    p {
      background: #d5d5d5;
      font-weight: 600;
      text-align: center;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media ${device.mobile} {
    h4 {
      font-size: 1.2rem;
      margin-bottom: 0.8rem;
    }
    section {
      gap: 1rem;
      margin-bottom: 0.5rem;

      div {
        height: 7rem;
        padding: 1.5rem;
      }
      p {
        font-size: 0.9rem;
      }
    }
  }
`;
